import { render, staticRenderFns } from "./accountPeriod.vue?vue&type=template&id=49984b08&scoped=true"
import script from "./accountPeriod.vue?vue&type=script&lang=js"
export * from "./accountPeriod.vue?vue&type=script&lang=js"
import style0 from "./accountPeriod.vue?vue&type=style&index=0&id=49984b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49984b08",
  null
  
)

export default component.exports